"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var context_1 = __importDefault(require("./context"));
/**
 * Provides the LaunchDarkly client initialization error, if there was one.
 *
 * @return The `launchdarkly-js-client-sdk` `LDClient` initialization error
 */


function useLDClientError() {
  var _ref = (0, react_1.useContext)(context_1.default),
      error = _ref.error;

  return error;
}

exports.default = useLDClientError;